import { createSlice } from "@reduxjs/toolkit";
import {
  deleteUser,
  editUser,
  editUserPlusDetail,
  getUserPage, 
  postUser,
  postUserPlusDetail,
} from "../action/userAction";

const initialState = {
  dataUser: [],
  dataByIdUser: [],
  dataUserByRegionalId: [],
  idUser: "",
  state: "",
  isOpenForm: false,
  isOpenFormEdit: false,
  isLoading: false,
  isLoadingEdit: false,
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    openForm: (state, action) => {
      state.isOpenForm = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdUser = []
        state.idUser = ''
      }
      if (action.payload.state === "edit") {
        state.dataByIdUser = action.payload.data;
        state.idUser = action.payload.id;
      } else if (action.payload.state === "delete") {
        state.dataByIdUser = action.payload.data;
        state.idUser = action.payload.id;
      }
    },
    openFormEdit: (state, action) => {
      state.isOpenFormEdit = action.payload.open;
      state.state = action.payload.state;
      if (action.payload.type === 'close') {
        state.dataByIdUser = []
        state.idUser = ''
      }
      if (action.payload.state === "editDetail") {
        state.dataByIdUser = action.payload.data;
        state.idUser = action.payload.id;
      }
    },
  },
  extraReducers: {
    [getUserPage.pending]: (state) => {
      state.isLoading = true;
    },
    [getUserPage.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.dataUser = action.payload.data
      state.isLoading = false
    },
    [getUserPage.rejected]: (state) => {
      state.isLoading = false;
    },
    [postUser.pending]: (state) => {
      state.isLoading = true;
    },
    [postUser.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.isOpenForm = false;
      state.isLoading = false;
    },
    [postUser.rejected]: (state) => {
      state.isLoading = false;
    },
    [postUserPlusDetail.pending]: (state) => {
      state.isLoading = true;
    },
    [postUserPlusDetail.fulfilled]: (state, action) => {
      // console.log(action.payload);
      state.isOpenForm = false;
      state.isLoading = false;
    },
    [postUserPlusDetail.rejected]: (state) => {
      state.isLoading = false;
    },
    [editUser.pending]: (state) => {
      state.isLoading = true;
    },
    [editUser.fulfilled]: (state, action) => {
      state.isOpenFormEdit = false;
      state.isLoading = false;
      state.dataByIdUser = [];
      state.idUser = 0;
    },
    // [editUserPlusDetail.rejected]: (state) => {
    //   state.isLoading = false;
    // },
    // [editUserPlusDetail.pending]: (state) => {
    //   state.isLoading = true;
    // },
    // [editUserPlusDetail.fulfilled]: (state, action) => {
    //   state.isOpenFormEdit = false;
    //   state.isLoading = false;
    //   state.dataByIdUser = [];
    //   state.idUser = 0;
    // },
    // [editUserPlusDetail.rejected]: (state) => {
    //   state.isLoading = false;
    // },
    [deleteUser.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteUser.fulfilled]: (state, action) => {
      state.isOpenForm = false;
      state.isLoading = false;
      state.dataByIdUser = [];
      state.idUser = 0;
    },
    [deleteUser.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { openForm, openFormEdit } = userSlice.actions;
export default userSlice.reducer;
